export const GET_TYPES_HEALTH = 'GET_TYPES_HEALTH';
export const CREATE_TYPE_HEALTH = 'CREATE_TYPE_HEALTH';
export const DELETE_TYPE_HEALTH = 'DELETE_TYPE_HEALTH';

export const GET_TYPES_BREAK = 'GET_TYPES_BREAK';
export const CREATE_TYPE_BREAK = 'CREATE_TYPE_BREAK';
export const DELETE_TYPE_BREAK = 'DELETE_TYPE_BREAK';
export const GET_USER_ASSIGNMENTS = 'GET_USER_ASSIGNMENTS';
